import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=2cf88436&scoped=true"
import script from "./AttributeEditor.vue?vue&type=script&lang=js"
export * from "./AttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf88436",
  null
  
)

export default component.exports